const MAX_WAITING_SECONDS = 60 * 20; // twenty minutes

export const getWaitTime = (waitDateString, retryDateString) => {
    const currentTime = new Date();
    const waitTime = new Date(waitDateString);
    const calcWaitTime = (waitTime - currentTime) / 1000;

    if (calcWaitTime > MAX_WAITING_SECONDS) {
        const retryTime = new Date(retryDateString);
        const calcRetryTime = (retryTime - currentTime) / 1000;

        return {
            message: 'retry',
            time: calcRetryTime
        };
    }

    return {
        message: 'estimate',
        time: calcWaitTime
    };
};

export default {
    getWaitTime
};
